import { pushEnrichedEventToDataLayerWithCleanUp } from "seneca-common/features/analytics";

const namespace = "s/surveys";

export function logSurveyToastShown(surveyId: string) {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: `${namespace}/surveyToastShown`,
    payload: {
      surveyId
    }
  });
}

export function logSurveyToastClicked(surveyId: string) {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: `${namespace}/surveyToastClicked`,
    payload: {
      surveyId
    }
  });
}

export function logSurveyToastClosed(surveyId: string) {
  pushEnrichedEventToDataLayerWithCleanUp({
    event: `${namespace}/surveyToastClosed`,
    payload: {
      surveyId
    }
  });
}
